module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integration"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("奖品配置\n\t\t"), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeIntegration
    }
  }, [_vm._v("更新奖品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "position",
      "label": "替换序号",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeName",
      "label": "奖品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('img', {
            staticStyle: {
              "display": "inline-block",
              "width": "150px",
              "margin-top": "5px"
            },
            attrs: {
              "src": _vm.row.imgUrl
            }
          })])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeCount",
      "label": "数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "probability",
      "label": "中奖概率",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "兑换时间",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.startTime && _vm.row.endTime) ? _c('div', [_vm._v(_vm._s(_vm.row.startTime) + " - " + _vm._s(_vm.row.endTime))]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近操作记录",
      "align": "center",
      "width": "200"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', [_vm._v(_vm._s(_vm.row.operator))]), _vm._v(" "), (_vm.row.startTime && _vm.row.endTime) ? _c('div', [_vm._v(_vm._s(_vm.row.operateTime))]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(!_vm.row.prizeName) ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.newIntegration(0, _vm.row)
              }
            }
          }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (_vm.row.prizeName) ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.toDet(_vm.row.position)
              }
            }
          }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (_vm.row.prizeName && !_vm.row.hasReplacePrize) ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.newIntegration(1, _vm.row)
              }
            }
          }, [_vm._v("编辑")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("活动替换\n\t\t"), _c('el-button', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toDownline(2)
      }
    }
  }, [_vm._v("已下线奖品")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toDownline(0)
      }
    }
  }, [_vm._v("待上线奖品")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.newIntegration(2)
      }
    }
  }, [_vm._v("添加替换奖品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "com-list",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.list_change
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "position",
      "label": "替换序号",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeName",
      "label": "奖品名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "图片",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('img', {
            staticStyle: {
              "display": "inline-block",
              "width": "150px",
              "margin-top": "5px"
            },
            attrs: {
              "src": _vm.row.imgUrl
            }
          })])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prizeCount",
      "label": "数量",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "替换时间",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.replaceStartTime && _vm.row.replaceEndTime) ? _c('div', [_c('div', [_vm._v(_vm._s(_vm.row.replaceStartTime) + " - " + _vm._s(_vm.row.replaceEndTime))])]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "兑换时间",
      "align": "center"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.startTime && _vm.row.endTime) ? _c('div', [_vm._v(_vm._s(_vm.row.startTime) + " - " + _vm._s(_vm.row.endTime))]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applicableCampus",
      "label": "学校",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "最近操作记录",
      "align": "center",
      "width": "200"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('div', [_vm._v(_vm._s(_vm.row.operator))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.row.operateTime))])])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(_vm.row.id) ? _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.toChangeDet(_vm.row)
              }
            }
          }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            staticClass: "option",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.unPublish(_vm.row)
              }
            }
          }, [_vm._v("下线")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-361d4b04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/integration/integration.vue
// module id = 986
// module chunks = 0